import { render } from "./InfoPickupBox.vue?vue&type=template&id=0a92cf44&scoped=true&ts=true"
import script from "./InfoPickupBox.vue?vue&type=script&lang=ts"
export * from "./InfoPickupBox.vue?vue&type=script&lang=ts"

import "./InfoPickupBox.vue?vue&type=style&index=0&id=0a92cf44&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0a92cf44"]])

export default __exports__